import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngxInit]',
  standalone: false
})
export class NgxInitDirective {
  private templateRef: TemplateRef<any> = inject(TemplateRef);
  public viewContainer: ViewContainerRef = inject(ViewContainerRef);

  @Input() set ngxInit(val: any) {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef, { ngxInit: val });
  }
}
